export default "__VITE_ASSET__DYF5MvnW__"